// import axios from 'axios';
import axiosInterface from './axiosInterface';
import axiosMAGMAInterface from './axiosMAGMAInterface';
import { TOKEN } from './constant';
import { getAuthToken } from './localStorage';
import { API, PAYRESP, PGAPI } from "./urls"
let header: any = {
  'Content-Type': 'application/json',
};

export const fetchPost = async (url: any, body: any) => {
  try {
    const API_URL = `${API}${url}`;
    if (url !== '/p2p/request-otp' && url !== '/p2p/login') header = { ...header, 'client-token': getAuthToken() || TOKEN }
    if (url === '/insuranceJourney/update-documents') header = { ...header, 'client-token': getAuthToken(), 'Content-Type': 'multipart/form-data' }
    if (url === '/p2p/create-ticket') header = { ...header, 'Content-Type': 'multipart/form-data' }
    const response = await axiosInterface.post(API_URL, body, { headers: header });
    if (response.status === 200) return response.data;
    return null;
  } catch (error: any) {
    if (error?.response) {
      return { error: error?.response?.data };
    }
    // const jsonString= JSON.stringify(error);
    // const jsonPrs= JSON.parse(jsonString);
    // return {error:jsonPrs};
  }
};

export const fetchGet = async (url: any) => {
  // const data = {
  //   "customer_id":1234
  // }
  try {
    const API_URL = `${API}${url}`;
    header = { ...header, 'client-token': getAuthToken() || TOKEN }
    const response = await axiosInterface.get(API_URL, { headers: header }); //, data: data
    return response.data;
  } catch (error: any) {
    const jsonString = JSON.stringify(error.response.data);
    const jsonPrs = JSON.parse(jsonString);
    return { error: jsonPrs };
  }
};
export const fetchMAGAMAGet = async (url: any) => {
  // const data = {
  //   "customer_id":1234
  // }
  try {
    const API_URL = `${API}${url}`;
    header = { ...header, 'client-token': getAuthToken() || TOKEN }
    const response = await axiosMAGMAInterface.get(API_URL, { headers: header }); //, data: data
    return response.data;
  } catch (error: any) {
    const jsonString = JSON.stringify(error.response.data);
    const jsonPrs = JSON.parse(jsonString);
    return { error: jsonPrs };
  }
};

export const fetchGetIfscCode = async (url: any) => {
  try {
    const response = await axiosInterface.get(url);
    return response.data;
  } catch (error: any) {
    let errorObj;
    if (error.response) {
      const jsonString = JSON.stringify(error.response.data);
      errorObj = JSON.parse(jsonString);
    } else {
      errorObj = "Invalid IFSC code";
    }
    return { error: errorObj };
  }
};


export const fetchPaymentGateway = async (url: any, body: any) => {
  try {
    const api = `${API}${url}`;
    const callbackURL = `${PGAPI}${PAYRESP}`
    const data = { ...body, callbackURL }
    header = { ...header, 'client-token': getAuthToken() }
    const response = await axiosInterface.post(api, data, { headers: header });
    return response.data;
  } catch (error: any) {
    const jsonString = JSON.stringify(error.response.data);
    const jsonPrs = JSON.parse(jsonString);
    return { error: jsonPrs };
  }
}
